export default "<input numeric decimals=\"2\" type=\"number\" placeholder='0.0'\n(keyup)=\"onClick($event.target.value)\"\n[(ngModel)]=\"value\">\n\n\n\n"